import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDocument } from "../../Persist/AbstractDocumentPersister";
import { stageMetaDataDocument } from "../../Stages/StagesDocument";
import * as documentStages from "../../Stages/StagesDocument";
import * as documentStatus from "../../LeadStatus/StatusDocument";
import shortTimeWorkTransformations from "../FormTransformations/shortTimeWorkTransformations";
import { fullFormDefinition as fullFormDefinitionShortTimeWork } from "../FormDefinitions/shortTimeWork";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { ShortTimeWork } from "../../../types/Products/ShortTimeWork/ShortTimeWork";

export const shortTimeWork: ProductData<ShortTimeWork> = {
  urlPart: "kurzarbeit",
  lbUrlPart: "kurzarbeit",
  label: translate("shortTimeWork.label"),
  generalLabel: translate("shortTimeWork.label"),
  apiUri: "short_time_works",
  persist: persistDocument,
  stages: stageMetaDataDocument,
  stageConstants: documentStages,
  minimumCaseStatus: documentStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: documentStages.STAGE_INCOMPLETE,
  setBackCaseStage: documentStages.STAGE_READY,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\Document\\ShortTimeWork",
  formTransformations: shortTimeWorkTransformations,
  formDefinition: () => [],
  formDefinitionExternals: () => [],
  fullFormDefinition: fullFormDefinitionShortTimeWork,
  productSpecificDefinition: () => [],
  productCategory: "employmentLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.shortTimeWork,
}
